<template>
  <div class="o-card u-padding-xsmall">
    <Tabs with-route :tabs="tabs">
      <template #permissions>
        <CyclePermissions :cycle="cycle" />
      </template>
      <template #changedLogs>
        <CycleChangedLogs :cycle="cycle" />
      </template>
    </Tabs>
  </div>
</template>

<script>
import Tabs from "@/components/Base/Tabs.vue";
import CyclePermissions from "@/components/CycleDetail/Tabs/CyclePermissions.vue";
import CycleChangedLogs from "@/components/CycleDetail/ChangedLogs.vue";
export default {
  components: {
    Tabs,
    CyclePermissions,
    CycleChangedLogs,
  },
  props: ["cycle"],
  data() {
    return {
      tabs: [
        {
          label: this.$t("cycleDetail.tabs.permissions"),
          tab: "permissions",
        },
        {
          label: this.$t("cycleDetail.cycleLogs"),
          tab: "changedLogs",
        },
      ],
    };
  },
};
</script>

<style></style>
